import { Component } from '@angular/core';
import { AgRendererComponent } from "ag-grid-angular";
import { DynamicDialogService } from "../../../core/services/dynamic-dialog.service";
import { Dialog, DialogButton } from "../../../core/models/dialog.model";

@Component({
    selector: 'app-modal-info',
    templateUrl: './modal-info.component.html',
    standalone: false
})
export class ModalInfoComponent implements AgRendererComponent {

    dialog: Dialog = new Dialog("No data available", [new DialogButton("OK", true, () => this.dialogClose())]);
    data: any;
    modalText: string;
    text: string;

    showDetailButton: boolean = false;

    constructor(private dialogService: DynamicDialogService) { }

    agInit(params) {
        this.data = params.data;
        this.showDetailButton = params.showDetailButton;
        if (!this.showDetailButton) {
            this.text = params.text(this.data);
            this.modalText = (params.modalText) ? (params.modalText(this.data)) : this.text;
            this.dialog = new Dialog(this.modalText, [new DialogButton("OK", true, () => this.dialogClose())]);
        } else {
            this.text = params.text(this.data);
            this.dialog = params.dialog(this.data);
        }
        if (this.dialog.buttons == null || this.dialog.buttons.length == 0) {
            this.dialog.buttons = [new DialogButton("OK", true, () => this.dialogClose())];
        }

        params.eGridCell?.addEventListener('keydown', (event: KeyboardEvent) => {
            if (event.key === ' ' || event.key === 'Enter') {
                event.preventDefault();
                this.onClick(event);
            }
        });
    }

    dialogClose() {
       
    }

    onClick(e: Event): void {
        this.dialog.toggleDialog(true);
        this.dialogService.updateDialog(this.dialog);
    }

    refresh(params: any): boolean { return false; }
}
